import React from 'react';
import Button from '../components/Button';

const CallForAction = () => (
	<section className="flex justify-center self-stretch py-10 mt-40 bg-neutral-900 max-md:mt-10">
		<div className="flex flex-col px-14 py-12 max-w-full text-center font-bold text-white bg-neutral-200 bg-opacity-30 rounded-[30px] w-[740px] max-md:px-5">
			<p className="text-4xl leading-[59px] max-md:max-w-full">
				Try on Devnet with a playground website...
			</p>
			<Button to={"/app/"} className="mt-9 w-56" background='linear-gradient(62deg, #E41B00 0%, #A7AA00 100%)'>
				Try Demo
			</Button>
		</div>
	</section>
)

export default CallForAction